<template>
    <div id="app">
        <div v-if="isShowMain" style="margin:0; padding:0; width:100%; height:100%;">
            <!-- route -->
            <router-view :key="$route.fullPath"></router-view>
            <!-- // route -->
        </div>
    </div>
</template>

<script>

    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        },

        data() {
            return {
                gubunPage: "APP"

                ,isShowMain: false
            };
        },

        methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , default() {

                // this
                let _this = this;

                // 시작
                _this.exec("DEFAULT");
            }

            // 실행
            , exec: function (gubun) {

                // this
                let _this = this;
                let url = "";
                let data = { "gubunProc": gubun, "gubunPage": _this.gubunPage };

                switch (gubun) {

                    case "DEFAULT":
                        {
                            let protocol = window.location.protocol;
                            let host = window.location.host;

                            // http => https로
                            if (protocol.indexOf("https") == -1
                                && !host.startsWith("localhost")) {

                                window.location.href = "https://" + host;
                            }
                            else {

                                // 1분 간격(JWT & AES256)
                                setInterval(async () => {
                                    _this.exec("SYSTEM_RESET_KEY");
                                }, 1000 * 60);

                                _this.exec("SYSTEM_RESET_KEY");
                            }

                            return;
                        }
                        break;

                    case "SYSTEM_RESET_KEY":
                        {
                            // API 조회
                            url = "/vue_api/common/common/init";                            
                        }
                        break;

                    default:
                        {

                        };
                }

                // API 조회
                _this.$SendPost(url, data, _this.execReturn);
            }

            // 리턴 데이터
            , execReturn: function (data, err) {

                // this
                let _this = this;

                switch (data.GUBUN_PROC) {

                    case "DEFAULT":
                        {

                        }
                        break;

                    case "SYSTEM_RESET_KEY":
                        {
                            if (data.RESULT_YN === "Y") {
                                this.isShowMain = true;
                            }
                        }
                        break;

                    default:
                        {

                        };
                }
            }
        },

        beforeCreate() {
            this.$PrintLog(this.gubunPage + " : beforeCreate");
        },

        created() {
            this.$PrintLog(this.gubunPage + " : created");
            this.default();
        },

        beforeMount() {
            this.$PrintLog(this.gubunPage + " : beforeMount");
        },

        mounted() {
            this.$PrintLog(this.gubunPage + " : mounted");            
        },

        beforeUpdate() {
            this.$PrintLog(this.gubunPage + " : beforeUpdate");
        },

        updated() {
            this.$PrintLog(this.gubunPage + " : updated");
        },

        beforeDestroy() {
            this.$PrintLog(this.gubunPage + " : beforeDestroy");
        },

        destroyed() {
            this.$PrintLog(this.gubunPage + " : destroyed");
        },
    };
</script>
